<template>
   <section class="content">
    <div class="container-fluid">
        <div class="row">

          <div class="col-12">
        
            <div class="card">
              <div class="card-header">
                <h3 class="card-title">Daftar Tunggu Approval Perubahan Harga <strong>Invoice</strong></h3>

                <div class="card-tools">
                </div>
              </div>
              <!-- /.card-header -->
              <v-app>
                <v-main>
                    <div class="card-body ">
                      <div class="row">
                        <div class="col-4">
                          <label>Jumlah Permintaan Terpilih:</label>
                          <h5>  {{ listItemSelekID.length }}</h5>
                        </div>
                        <div class="col-4">
                          <!--label>Jumlah Rp Terpilih:</label>
                          <h5>  {{ listItemSelekRP | toCurrency }}</h5-->
                        </div>
                        <div class="col-2">
                          <button type="button" class="btn btn-success float-right" :disabled="listItemSelekID.length < 1" @click="updateApprovalTerima()"> Terima</button>
                        </div>
                        <div class="col-2">
                          <button type="button" class="btn btn-danger float-left" :disabled="listItemSelekID.length < 1" @click="tolakModalMasal()"> Tolak</button>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-12">
                          <v-text-field
                              class="col-md-4 offset-md-8 mb-1"
                              v-model="cari_dt"
                              append-icon="mdi-magnify"
                              label="Pencarian"
                              single-lineactions
                              hide-details
                          ></v-text-field>
                          <v-data-table
                              :headers="headers"
                              :footer-props="{ itemsPerPageOptions: [10,25,50,100,-1]}"
                              :items="datas"
                              :items-per-page="25"
                              item-key="id"
                              sort-by="id"
                              class="elevation-1 "
                              :search="cari_dt">
                              <template v-slot:header.checkbox>
                                  <input type="checkbox" @click="checkAll()" v-model="isCheckAll">
                              </template>
                              <template v-slot:item.checkbox="{ item }">
                                  <v-container
                                      class="px-0"
                                      fluid
                                  >
                                      <v-checkbox @change="updateCheckall(item)" :id="'ch_'+item.id" :multiple="true" v-model="listItemSelekID"  :value="item.id"
                                      ></v-checkbox>
                                  </v-container>
                              </template>
                              <template v-slot:item.detail_invoice.bulan_pemakaian="{ item }">
                              {{ getBulan(item.detail_invoice.bulan_pemakaian) }}
                              </template>
                              <template v-slot:item.total_bayar_lama="{ item }">
                              {{ item.total_bayar_lama | toCurrency }}
                              </template>
                              <template v-slot:item.total_bayar_baru="{ item }">
                              <strong>{{ item.total_bayar_baru | toCurrency }}</strong>
                              </template>
                              <!--template v-slot:item.actions="{ item }">
                                  <div class="tanpawrap">
                                  <a href="#" @click="terimaModal(item.id, item.kantor_id, item.jumlah, item.kategori_id, item.keterangan, item.created_by)" class="mr-1" title="Terima">
                                      <i class="fa fa-check text-green"></i>
                                  </a>
                                  /
                                  <a href="#" @click="tolakModal(item.id)" class="ml-1" title="Tolak">
                                      <i class="fas fa-times text-red"></i>
                                  </a>
                                  </div>
                              </template-->
                              <template v-slot:no-data>
                              <h4>Data Tidak Ditemukan</h4>
                              </template>
                          </v-data-table>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-4">
                          <label>Jumlah Permintaan Terpilih:</label>
                          <h5>  {{ listItemSelekID.length }}</h5>
                        </div>
                        <div class="col-4">
                          <!--label>Jumlah Rp Terpilih:</label>
                          <h5>  {{ listItemSelekRP | toCurrency }}</h5-->
                        </div>
                        <div class="col-2">
                          <button type="button" class="btn btn-success float-right" :disabled="listItemSelekID.length < 1" @click="updateApprovalTerima()"> Terima</button>
                        </div>
                        <div class="col-2">
                          <button type="button" class="btn btn-danger float-left" :disabled="listItemSelekID.length < 1" @click="tolakModalMasal()"> Tolak</button>
                        </div>
                      </div>
                    </div>
                </v-main>
              </v-app>
            </div>
            <!-- /.card -->
          </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="tolakModalMasal" tabindex="-1" role="dialog" aria-labelledby="tolakModal" aria-hidden="true" data-backdrop="static" data-keyboard="false">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Tolak Permintaan </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeTolakMasal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <form @submit.prevent="tolakPermintaanMasal()" id="formTolakMasal">
                        <div class="modal-body">
                            <div class="form-group">
                                <label>Alasan Tolak</label>
                                <textarea v-model="tolak_alasan_masal" style="resize:none" rows="3" class="form-control" required></textarea>
                            </div>
                            <br/>
                            Yakin Untuk Menolak Permintaan Terpilih? 
                             <!--input type="hidden" v-model="tolak_id"-->
                             
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeTolakMasal()">Close</button>
                            <button type="submit" class="btn btn-danger">Tolak</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>

        <div class="modal fade" id="KeteranganModal" tabindex="-1" role="dialog" aria-labelledby="KeteranganModal" aria-hidden="true" data-backdrop="static" data-keyboard="false" >
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title"> Keterangan Pengeluaran </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="closeKeteranganModal()">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                      
                    <div class="modal-body">
                      <div class="row">
                        <div class="col-md-12">
                          {{tampilKet}}
                        </div>
                      </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="closeKeteranganModal()">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
  </section>
</template>

<script>
    export default {
        data () {
            return {
                isCheckAll: false,
                listItemSelekID: [],
                listItemSelekRP: 0,
                tampilKet : '',
                tolak_alasan : '',
                tolak_alasan_masal : '',
                terima_id : '',
                terima_kantor_id : '',
                terima_jumlah_rp : '',
                terima_kategori_id : '',
                //terima_url_bukti : '',
                terima_keterangan : '',
                terima_created_by : '',
                datas : [],
                cari_dt: '',
                headers: [
                  { text: "semua", align: 'start', value: 'checkbox', sortable: false, groupable: false, },
                  { text: 'Invoice ID', value: 'detail_invoice.id'},
                  { text: 'Nama PLG', value: 'detail_invoice.pelanggan_internet.nama'},
                  { text: 'Bulan Pakai', value: 'detail_invoice.bulan_pemakaian'},
                  
                  //{ text: 'Oleh', value: 'prorate_created_by.name'},
                  //{ text: 'Tanggal Pengajuan', value: 'created_at'},
                  { text: 'Total Bayar Lama', value: 'total_bayar_lama'},
                  { text: 'Total Bayar Baru', value: 'total_bayar_baru'},
                  { text: 'Alasan', value: 'keterangan'},
                  //{ text: 'Data', value: 'value', sortable: false, class:"text-center" },
                  //{ text: 'Aksi', value: 'actions' , sortable: false},
                ],
            }
        },
        filters: {
            pretty: function(value) {
            return JSON.stringify(JSON.parse(value), null, 2);
            }
        },
        methods: {
          getBulan(tanggal){
            var tgltemp = new Date(tanggal);
            var tahun = tgltemp.getFullYear();
            var bulan = ["Januari","Februari","Maret","April","Mei","Juni","Juli","Agustus","September","Oktober","November","Desember"];

            var now = new Date();
            if (
              (tahun == now.getFullYear()) &&
              (tgltemp.getMonth() == now.getMonth()) 
            ) {
              this.kunci = false;
            }else{
              this.kunci = true;
            }
            
            return (bulan[tgltemp.getMonth()] + " " + tahun);
          },
          updateApprovalTerima(){
            this.$Progress.start();
            Swal.fire({
              title: 'Are you sure?',
              text: "Apakah Anda Yakin Untuk Menerima Permintaan Pengeluaran Terpilih?",
              showCancelButton: true,
              confirmButtonColor: '#d33',
              cancelButtonColor: '#3085d6',
              confirmButtonText: 'Yes!'
            }).then((result) => {
              if (result.value) {
                let editFormData = new FormData();
                let dataUpdate = {};
                dataUpdate['id'] = this.listItemSelekID;
                dataUpdate['status'] = '1';
                //dataUpdate['rp'] = this.listItemSelekRP;
                //dataUpdate['fulldata'] = this.listItemSelek;

                editFormData.append('datanya', JSON.stringify(dataUpdate));
                axios.post('api/approval/terimaPermintaanInvoiceMasal', editFormData).then((data) => {
                  if(data.data.success){

                      Toast.fire({
                          icon: 'success',
                          title: data.data.message
                      });
                      
                      this.$Progress.finish();
                      this.loadData();
                      this.isCheckAll= false;
                      this.listItemSelekID= [];
                      this.listItemSelekRP= 0;
                      
                  } else {
                      Toast.fire({
                          icon: 'error',
                          title: data.data.data ? data.data.data : "Error!. Try again later."
                      });

                      this.$Progress.fail();
                  }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!."
                    });
                    //console.log( e.response.data.errors);

                    this.$Progress.fail();
                });
              }else{
                this.$Progress.fail();
              }
            })
          },
          checkAll(){
            this.isCheckAll = !this.isCheckAll;
            this.listItemSelekID = [];
            this.listItemSelekRP = 0;
            
            if(this.isCheckAll){ // Check all
              for (var key in this.datas) {
                this.listItemSelekID.push(this.datas[key].id);
                this.listItemSelekRP += parseFloat(this.datas[key].jumlah);
              }
            }
          },
          updateCheckall(e){
            const indexRemove = this.listItemSelekID.indexOf(e.id);
            if(indexRemove > -1 ){
              this.listItemSelekRP -= parseFloat(e.jumlah);
            }else{
              this.listItemSelekRP += parseFloat(e.jumlah);
            }
            if(this.listItemSelekID.length == this.datas.length){
              this.isCheckAll = true;
            }else{
              this.isCheckAll = false;
            }
          },
          loadData(){
            if(this.$gate.isAllowed("is_approval")){
              axios.get("api/approval/list_unapproved_invoice").then(({ data }) => (this.datas = data.data));
            }
          },
          bukaKeteranganModal(ket){
            this.tampilKet = ket;
            $('#KeteranganModal').modal('show');
          },
          closeKeteranganModal(){
            this.tampilKet = '';
            $('#KeteranganModal').modal('hide');
          },
          closeTolakMasal(){
            this.tolak_alasan_masal = '';
            $('#tolakModalMasal').modal('hide');
          },
          tolakModalMasal(id){
            $('#tolakModalMasal').modal('show');
          },
          tolakPermintaanMasal(){
                let editFormData = new FormData();
                let dataUpdate = {};
                dataUpdate['id'] = this.listItemSelekID;
                dataUpdate['status'] = '2';
                dataUpdate['keterangan'] = this.tolak_alasan_masal;

                editFormData.append('datanya', JSON.stringify(dataUpdate));
                //this.form.put('api/pppoe/'+this.form.id)
                axios.post('api/approval/tolakPermintaanInvoiceMasal', editFormData)
                .then((data) => {
                if(data.data.success){

                    Toast.fire({
                        icon: 'success',
                        title: data.data.message
                    });
                    this.isCheckAll= false;
                    this.listItemSelekID= [];
                    this.listItemSelekRP= 0;
                    this.$Progress.finish();
                    this.loadData();
                    this.closeTolakMasal();
                } else {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!. Try again later."
                    });

                    this.$Progress.fail();
                }
                })
                .catch(e => {
                    Toast.fire({
                        icon: 'error',
                        title: data.data.data ? data.data.data : "Error!."
                    });

                    this.$Progress.fail();
                });
            //}
          },
        },
        mounted() {
            
        },
        created() {
            this.$Progress.start();

            this.loadData();

            this.$Progress.finish();
        }
    }
</script>
<style scoped>


.tanpawrap {
  white-space: nowrap;
}
</style>